module.exports = __webpack_public_path__ + "img/Path 19@3x.ea0e6346.png";